// src/pages/Unauthorized.tsx
import { Box, Paper, Typography } from '@mui/material';
import React from 'react';

import CPActionButton from '../components/atoms/CPActionButton';
import useSession from '../hooks/useSession';

export default function Unauthorized() {
  const { handleLogout } = useSession();

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        display: 'grid',
        placeItems: 'center',
        bgcolor: '#FAFAFA',
        p: 2,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: 4,
          borderRadius: 3,
          maxWidth: 520,
          width: '100%',
          textAlign: 'center',
          border: '1px solid #eee',
          bgcolor: '#fff',
          boxSizing: 'border-box',
        }}
      >
        <Typography variant="h4" fontWeight={700} mb={1}>
          You’re not authorized
        </Typography>

        <Typography variant="body1" color="text.secondary" mb={3}>
          This account doesn’t have access to this application or report.
        </Typography>

        <CPActionButton appearance="primary" onClick={handleLogout}>
          {' '}
          Sign in with a different account
        </CPActionButton>
      </Paper>
    </Box>
  );
}
